import { useStaticQuery, graphql } from 'gatsby';

export const useNavbarData = (locale: string) => {
  const navbarData = useStaticQuery(graphql`
    {
      allContentfulNavbar {
        nodes {
          enabled
          node_locale
          navtabs {
            contentful_id
            title
            columns {
              id
              backgroundColor
              sections {
                title
                columnWidth
                items {
                  variant
                  title
                  bulletColor
                  description
                  icon
                  iconPosition
                  image {
                    file {
                      url
                    }
                    description
                  }
                  pillColor
                  pillTitle
                  isExternalLink
                  linkPath
                }
                superlinkTitle
                superlinkPath
              }
            }
          }
          languages {
            languages {
              link {
                path
                isExternal
              }
              title
              abbreviation
            }
          }
          footerLinks {
            footerLinks {
              title
              path
              isExternal
            }
          }
        }
      }
    }
  `);

  const localisedNavbarData = navbarData.allContentfulNavbar.nodes.find(
    node => node.enabled && node.node_locale === locale
  );

  return localisedNavbarData;
};
